import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-stop",
  "use": "icon-stop-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-stop\"><defs><style></style></defs><path d=\"M512 1024C230.4 1024 0 793.6 0 512S230.4 0 512 0s512 230.4 512 512-230.4 512-512 512zm0-960C265.582 64 64 265.582 64 512s201.582 448 448 448 448-201.582 448-448S758.418 64 512 64zm128 640H384a64.22 64.22 0 0 1-64-64V384c0-35.182 28.818-64 64-64h256c35.182 0 64 28.818 64 64v256a64.22 64.22 0 0 1-64 64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol